// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as React from "react";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
function Popup(Props) {
  var position = Props.position;
  var showOpt = Props.show;
  var classNameOpt = Props.className;
  var dataTestId = Props.dataTestId;
  var children = Props.children;
  var show = showOpt !== undefined ? showOpt : true;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var px = position.bottom;
  var tmp;
  tmp = typeof px === "number" ? undefined : px.TAG === /* Px */0 ? CSS$Showside.intToPx(px._0) : CSS$Showside.floatToPercentage(px._0 * 100);
  var px$1 = position.left;
  var tmp$1;
  tmp$1 = typeof px$1 === "number" ? undefined : px$1.TAG === /* Px */0 ? CSS$Showside.intToPx(px$1._0) : CSS$Showside.floatToPercentage(px$1._0 * 100);
  var px$2 = position.right;
  var tmp$2;
  tmp$2 = typeof px$2 === "number" ? undefined : px$2.TAG === /* Px */0 ? CSS$Showside.intToPx(px$2._0) : CSS$Showside.floatToPercentage(px$2._0 * 100);
  var px$3 = position.top;
  var tmp$3;
  tmp$3 = typeof px$3 === "number" ? undefined : px$3.TAG === /* Px */0 ? CSS$Showside.intToPx(px$3._0) : CSS$Showside.floatToPercentage(px$3._0 * 100);
  var match = position.left;
  var match$1 = position.right;
  var tmp$4;
  tmp$4 = typeof match === "number" || !(match.TAG === /* Px */0 && !(typeof match$1 === "number" || match$1.TAG !== /* Px */0)) ? "100%" : "auto";
  var tmp$5 = {
    maxWidth: "370px",
    width: tmp$4
  };
  if (tmp !== undefined) {
    tmp$5.bottom = tmp;
  }
  if (tmp$1 !== undefined) {
    tmp$5.left = tmp$1;
  }
  if (tmp$2 !== undefined) {
    tmp$5.right = tmp$2;
  }
  if (tmp$3 !== undefined) {
    tmp$5.top = tmp$3;
  }
  var style = tmp$5;
  if (!show) {
    return null;
  }
  var tmp$6 = {
    children: React.createElement("div", {
      className: Cn.make([CSS$Showside.prefix("bg-main absolute rounded-lg shadow-xl flex flex-col space-y-4 pointer-events-auto ring-1 ring-black ring-opacity-5"), className]),
      style: style
    }, children)
  };
  if (dataTestId !== undefined) {
    tmp$6.dataTestId = Caml_option.valFromOption(dataTestId);
  }
  return React.createElement(DataAttribute$Showside.make, tmp$6);
}
Popup.displayName = "Popup";
var make = Popup;
export { make };
/* react Not a pure module */